import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import { useAuth } from "./AuthProvider";
import { useTranslation } from 'react-i18next';
import { ADMIN, GAME_MASTER } from './Roles';

function NavigationBar() {
  const auth = useAuth();
  const { t } = useTranslation();

  const showUsername = auth.roles?.includes(ADMIN);

  return (
    <Navbar bg="dark">
      <Container fluid>
        <Navbar.Collapse className="justify-content-end">
          <Navbar.Text className="text-light">
            {showUsername && <>{t('navigation-bar.user')} <span className="fw-bold pe-2">{auth.user}</span> | </>}
              <a href="logout" className="text-light p-2" onClick={() => auth.logOut()}>{t('navigation-bar.logout')}</a>
          </Navbar.Text>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavigationBar;